import React from 'react';

var ProvideEmailPopup = React.createClass({
	getInitialState: function(){
		return {value: "", errMsg: "", errclas: ""}
	},
	handleCloseClick: function() {
		this.props.provideEmail("close");
	},
	handleSendClick: function(){
		// re for email
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if(re.test(this.state.value)){
			this.props.provideEmail("submit", this.state.value.toLowerCase());
		} else {
			this.setState({errMsg: "Please enter a valid email.", errclas: "field__error--input"});
		}
	},
	handleChange: function(e){
		this.setState({value: e.target.value, errMsg: "", errclas: ""});
	},
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	render: function(){
		return(
		<div className="modal__mask" onClick = {this.handleCloseClick}>
			<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
			  <div className="modal__header">
			    <h3 className="modal__header--title">Please Provide Your Email</h3>
			    <a href="javascript:void(0)" onClick = {this.handleCloseClick} className="modal__close"><i className="fa  fa-close"> </i></a> </div>
			  <div className="modal__body clearfix">
			    <div className="form__row clearfix">
			      <p>We ask that you provide and validate your email before your share with other users.</p>
			    </div>
			    <div className="form__row clearfix">      
			      <div className="form__cell">
			      	{this.state.errMsg ?
				    <p className ="field__error--text">{this.state.errMsg}</p> : null }
				    <div className={this.state.errclas}>
			        	<input type="text" onChange = {this.handleChange} value={this.state.value}/>        
			        </div>
			      </div>
			    </div>
			    <div className="buttons clearfix">      
			      <button className="btn__lg bg-very_light" onClick = {this.handleCloseClick}>Cancel</button>
			      <button className="btn__lg bg-dark" onClick = {this.handleSendClick}>Continue</button>
			    </div>
			  </div>  
			</div>
		</div>
		);
	}
});

export {ProvideEmailPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ProvideEmailPopup.jsx
 **/